$('.subscribe-form-js').submit(function (e) {
    e.preventDefault();
    let data = $(this).serialize();
    $.post(this.action, data, response => {
        let message = response.status ?
            'Спасибо, что вы подписались на нашу рассылку. Пожалуйста, перейдите по ссылке в высланном вам письме для подтверждения подписки.' :
            'Произошла ошибка при подписке на новости. Попробуйте позже';

        let modal = new tingle.modal({
            closeLabel: '',
            onClose(){
                modal.destroy();
            },
        });
        modal.setContent(message);
        modal.open();
    });
});